import React from "react";
import { motion } from "framer-motion";

const teamMembers = [
  {
    name: "Ravi Kumar",
    title: "Founder & Chairman",
    bio: "Visionary leader with 15+ years in real estate development and strategic planning.",
    image: "/team/ravi.jpg",
  },
  {
    name: "Sushma Rao",
    title: "Managing Director",
    bio: "Expert in finance and operations with a strong background in real estate funding.",
    image: "/team/sushma.jpg",
  },
  {
    name: "Anil Reddy",
    title: "Chief Architect",
    bio: "Designs sustainable and modern living spaces with architectural precision.",
    image: "/team/anil.jpg",
  },
  {
    name: "Meghana Iyer",
    title: "Marketing Head",
    bio: "Drives brand growth with innovative campaigns and digital strategies.",
    image: "/team/meghana.jpg",
  },
];

const TeamBoard = () => {
  return (
    <div className="bg-black text-white py-32 px-6 h-full">
      <motion.h2
        className="text-4xl font-bold text-yellow-600 text-center mb-12"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Meet Our Team
      </motion.h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4  max-w-7xl mx-auto">
        {teamMembers.map((member, index) => (
          <motion.div
            key={index}
            className="bg-gray-900 overflow-hidden shadow-lg hover:shadow-yellow-600/30 transition duration-500"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
          >
            <img
              src={member.image}
              alt={member.name}
              className="w-full h-60 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl font-semibold text-yellow-500 mb-1">{member.name}</h3>
              <p className="text-yellow-600 font-medium mb-2">{member.title}</p>
              <p className="text-gray-300 text-sm">{member.bio}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default TeamBoard;
